import {AdminPagingModel} from "./AdminPagingModel";
import {SensorReading} from "../../entities/SensorReadingHistory";
import {SensorService} from "../../services/SensorService";
import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class SensorAdminPagingModel extends AdminPagingModel<SensorReading>{
    static $inject = ['$q','SensorService','NotificationService','ApplicationSettingService','GridBookmarkService'];
    useFahrenheit:boolean = true;
    useMeters:boolean = true;
    constructor($q:ng.IQService,
                pagingService:SensorService,
                notificationService:NotificationService,
                public applicationSettingService:ApplicationSettingService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "sensor";
    }
    displayName():string{
        return "V-Tag Sensors";
    }
    addEditAllowed():boolean{
      return false;
    }
    deleteAllowed():boolean{
      return false;
    }
    transformItem(entity:SensorReading){
    }
    getColumnDefs():ng.IPromise<void>{
      return this.applicationSettingService.getCached().then((data)=>{
        this.useFahrenheit = data.temperatureFormat == "Fahrenheit";
        this.useMeters = data.useMeters;
        this.nameValuePairs =
          [
            ['created', 'Created', 200],
            ['vTagID', 'V-Tag ID', 120],
            ['vTagType', 'V-Tag Type', 145],
            ['assetName', 'Asset Name', 130],
            ['sourceDistanceHops', 'Source Distance Hops', 250],
            ['ttl', 'TTL', 90],
            ['minimumTemperatureDegC', 'Min Temp', 310],
            ['maximumTemperatureDegC', 'Max Temp', 135],
            ['maximumAccelerationG', 'Max Accel G', 150],
            ['batteryVolts', 'Battery Volts', 145],
            ['x', 'X', 145],
            ['y', 'Y', 145],
            ['z', 'Z', 145],
            ['locationConfidence', 'Location Confidence', 145],
            ['latitude', 'Latitude', 145],
            ['longitude', 'Longitude', 145],
            ['altitude', 'Altitude', 145],
            ['numberOfSatellites', 'Number Of Satellites', 145],
            ['lastGPSFix', 'Last GPS Fix', 145],
            ['gpsAccuracy', 'GPS Accuracy', 145],
            ['parentVTag', 'Parent V-Tag', 145],
          ];
        return this.$q.when();
      });
    }
}
